import type { HeroModel, OrderDetailsV2Normalized } from "../types";

// Re-export types for backward compatibility
export type { HeroModel };

const safeText = (value: unknown, fallback: string) =>
  value === undefined || value === null || value === ""
    ? fallback
    : String(value);

export const mapHero = (n: OrderDetailsV2Normalized): HeroModel => {
  const hero =
    (n.byId["COMPONENT_ORDER_DETAILS_PAGE_TITLE"] as
      | import("../types").HeroComponentData
      | undefined) || {};
  const header = hero?.header || {};
  const style = header?.style || {};
  const headerIcon = style?.backgroundImage || header?.icon || "";
  const headerBgColor = Array.isArray(style?.backgroundColor)
    ? style.backgroundColor[0]
    : (style?.backgroundColor as string | undefined);

  return {
    title: safeText(header?.title, ""),
    orderIdLabel: safeText(header?.subTitle, ""),
    icon: safeText(headerIcon, ""),
    bgColor: safeText(headerBgColor, ""),
  };
};
